import { render, staticRenderFns } from "./vc-drawer.vue?vue&type=template&id=10807492&scoped=true&"
import script from "./vc-drawer.vue?vue&type=script&lang=js&"
export * from "./vc-drawer.vue?vue&type=script&lang=js&"
import style0 from "./vc-drawer.vue?vue&type=style&index=0&id=10807492&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10807492",
  null
  
)

export default component.exports